import { useContext, useEffect, useRef } from 'react';
import { CardPingContext } from '../contexts/CardPingContext';

/** Pulse the card's filament whenever `value` changes (not on mount). */
export function usePingOn(value: unknown) {
  const ping = useContext(CardPingContext);
  const prev = useRef(value);
  useEffect(() => {
    if (Object.is(prev.current, value)) return;
    prev.current = value;
    ping();
  }, [value, ping]);
}
